var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_7",
    "data-name": "Rectangle 7",
    width: 256,
    height: 256,
    transform: "translate(1011.296 2267.616)",
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Goals",
    transform: "translate(-1011.296 -2267.616)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    "data-name": "Group 20",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    "data-name": "Group 19"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Icon_awesome-cloud",
    "data-name": "Icon awesome-cloud",
    d: "M1070.948,2363.419a8.067,8.067,0,0,0-12.009-9.614,13.448,13.448,0,0,0-25.1,6.706c0,.227.008.455.017.682a12.105,12.105,0,0,0,4.017,23.522h20.081",
    fill: "none",
    stroke: "#030504",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_6",
    "data-name": "Ellipse 6",
    cx: 70.57,
    cy: 70.57,
    r: 70.57,
    transform: "translate(1109.31 2324.068)",
    fill: "#dae0e8"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    "data-name": "Group 12"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_13",
    "data-name": "Path 13",
    d: "M1200.96,2396.9l13.95-13.95,12.325,12.325,30.339-30.338",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_14",
    "data-name": "Path 14",
    d: "M1248.317,2358.762h15.426v14.4",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_7",
    "data-name": "Ellipse 7",
    cx: 42.533,
    cy: 42.533,
    r: 42.533,
    transform: "translate(1027.636 2399.374)",
    fill: "#dae0e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_3",
    "data-name": "Rectangle 3",
    d: "M0,0H8A0,0,0,0,1,8,0V48a4,4,0,0,1-4,4H4a4,4,0,0,1-4-4V0A0,0,0,0,1,0,0Z",
    transform: "translate(1093.352 2461.501) rotate(45)",
    fill: "#fe9d2d",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_4",
    "data-name": "Rectangle 4",
    d: "M4,0H4A4,4,0,0,1,8,4V52a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V4A4,4,0,0,1,4,0Z",
    transform: "translate(1200.666 2498.271) rotate(135)",
    fill: "#fe9d2d",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Rectangle_5",
    "data-name": "Rectangle 5",
    d: "M4,0H4A4,4,0,0,1,8,4V52a0,0,0,0,1,0,0H0a0,0,0,0,1,0,0V4A4,4,0,0,1,4,0Z",
    transform: "translate(1123.796 2325.715)",
    fill: "#fe9d2d",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_8",
    "data-name": "Ellipse 8",
    cx: 69.5,
    cy: 69.5,
    r: 69.5,
    transform: "translate(1057.796 2342.715)",
    fill: "#004092",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_9",
    "data-name": "Ellipse 9",
    cx: 44.5,
    cy: 44.5,
    r: 44.5,
    transform: "translate(1082.796 2368.715)",
    fill: "#fff",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_10",
    "data-name": "Ellipse 10",
    cx: 17.5,
    cy: 17.5,
    r: 17.5,
    transform: "translate(1109.796 2395.715)",
    fill: "#004092",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_15",
    "data-name": "Path 15",
    d: "M1234.3,2307.265l-3.463-18.3-26.133,26.132a28.789,28.789,0,0,0-8.343,18.088l-.612,7.743-69.885,69.885a3.108,3.108,0,0,0,4.4,4.4l70.035-70.035,7.463-.534a28.781,28.781,0,0,0,18.3-8.359l26.045-26.045Z",
    fill: "#fe9d2d",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    "data-name": "Group 13"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_23",
    "data-name": "Line 23",
    y2: 3.963,
    transform: "translate(1239.662 2420.169)",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_24",
    "data-name": "Line 24",
    y2: 3.963,
    transform: "translate(1239.662 2409.865)",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_25",
    "data-name": "Line 25",
    x1: 3.963,
    transform: "translate(1232.529 2416.998)",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_26",
    "data-name": "Line 26",
    x1: 3.963,
    transform: "translate(1242.833 2416.998)",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    "data-name": "Group 14"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_27",
    "data-name": "Line 27",
    y2: 6.783,
    transform: "translate(1165.738 2319.349)",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_28",
    "data-name": "Line 28",
    y2: 6.783,
    transform: "translate(1165.738 2301.715)",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_29",
    "data-name": "Line 29",
    x1: 6.783,
    transform: "translate(1153.529 2313.923)",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_30",
    "data-name": "Line 30",
    x1: 6.783,
    transform: "translate(1171.164 2313.923)",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    "data-name": "Group 15"
  }, /*#__PURE__*/React.createElement("line", {
    id: "Line_31",
    "data-name": "Line 31",
    x1: 3.129,
    y1: 3.129,
    transform: "translate(1014.848 2458.102)",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_32",
    "data-name": "Line 32",
    x1: 3.129,
    y1: 3.129,
    transform: "translate(1014.848 2442.792)",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_33",
    "data-name": "Line 33",
    x1: 3.129,
    y1: 3.129,
    transform: "translate(1014.848 2427.482)",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_34",
    "data-name": "Line 34",
    x1: 3.129,
    y1: 3.129,
    transform: "translate(1030.158 2458.102)",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_35",
    "data-name": "Line 35",
    x1: 3.129,
    y1: 3.129,
    transform: "translate(1030.158 2442.792)",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_36",
    "data-name": "Line 36",
    x1: 3.129,
    y1: 3.129,
    transform: "translate(1030.158 2427.482)",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_37",
    "data-name": "Line 37",
    x1: 3.129,
    y1: 3.129,
    transform: "translate(1046.34 2458.102)",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_38",
    "data-name": "Line 38",
    x1: 3.129,
    y1: 3.129,
    transform: "translate(1046.34 2442.792)",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_39",
    "data-name": "Line 39",
    x1: 3.129,
    y1: 3.129,
    transform: "translate(1046.34 2427.482)",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("line", {
    id: "Line_40",
    "data-name": "Line 40",
    y1: 24.5,
    x2: 24.5,
    transform: "translate(1203.796 2313.215)",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    "data-name": "Group 18"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    "data-name": "Group 16"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_6",
    "data-name": "Rectangle 6",
    width: 37.172,
    height: 37.172,
    rx: 6,
    transform: "translate(1215.161 2438.021) rotate(45)",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    "data-name": "Group 17"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_16",
    "data-name": "Path 16",
    d: "M1216.81,2464.294l-3.565.039a3.56,3.56,0,0,1-3.563-3.556h0a3.56,3.56,0,0,1,3.485-3.634l6.314-.069",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17",
    "data-name": "Path 17",
    d: "M1213.513,2464.33l3.565-.039a3.561,3.561,0,0,1,3.564,3.556h0a3.562,3.562,0,0,1-3.485,3.634l-6.409.07",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_18",
    "data-name": "Path 18",
    d: "M1215.639,2455.329l-.019-1.786.019,1.786.02,1.787Z",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_19",
    "data-name": "Path 19",
    d: "M1215.836,2473.282l-.02-1.787.02,1.787.02,1.786Z",
    fill: "none",
    stroke: "#040505",
    strokeLinecap: "round",
    strokeMiterlimit: 10,
    strokeWidth: 2
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoals);
export default __webpack_public_path__ + "static/media/Goals.97087c7ab8c9b1ab9394d74ec4f62cb7.svg";
export { ForwardRef as ReactComponent };